/*****************************************
FILTERS/SORT - FORMERLY IN THEME.JS
******************************************/

// Resize Function
let W_width = window.innerWidth;
let W_height = window.innerHeight;

window.addEventListener('resize', () => {
  if (window.innerWidth !== W_width || window.innerHeight !== W_height) {
    W_width = window.innerWidth;
    W_height = window.innerHeight;
    _initResize();
  }
});

function _initResize() {
  replaceElement('.filter-refine');
  replaceElement('.filter-overlay, .filter__close, .filter__apply');
  replaceElement('.filter-sort__title');

  document.removeEventListener('click', handleDocumentClickResize);

  document.querySelector('.filter-sort-overlay')?.classList.remove('filter-sort-overlay--active');
  document.querySelector('.filters__container')?.classList.remove('filters__container--sticky');
  document.documentElement.classList.remove('no-scroll');
  setTimeout(() => {
    document.querySelector('.filters')?.classList.remove('filters--active');
  }, 500);

  const filterSortList = document.querySelector('.filter-sort__list');
  if (filterSortList) filterSortList.style.display = '';

  const width = window.innerWidth;

  // Filters Mobile/Tablet
  if (width < 1365) {
    document.querySelector('.filter-refine')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); // add this
      document.querySelector('.filter')?.classList.toggle('filter--active');
      document.querySelector('.filter')?.classList.remove('filter--off');
      document.querySelector('.filters__container')?.classList.remove('filters__container--sticky');
      document.querySelector('.filter-overlay')?.classList.add('filter-overlay--active');
      document.documentElement.classList.add('no-scroll');
      document.querySelector('.filters')?.classList.add('filters--active');
    });

    document.querySelectorAll('.filter-overlay, .filter__close, .filter__apply').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.filter')?.classList.remove('filter--active');
        document.querySelector('.filter-overlay')?.classList.remove('filter-overlay--active');
        document.documentElement.classList.remove('no-scroll');
        setTimeout(() => {
          document.querySelector('.filters')?.classList.remove('filters--active');
          document.querySelector('.filter')?.classList.add('filter--off');
        }, 500);
      });
    });
  }

  // Sort Tablet/Desktop
  if (width > 599) {
    document.querySelectorAll('.filter-sort__title').forEach(title => {
      title.addEventListener('click', (e) => {
        e.preventDefault();
        const list = title.nextElementSibling;
        const container = title.closest('.filters__container') ?? document;
        if (list?.classList.contains('filter-sort__list--active')) {
          list.classList.remove('filter-sort__list--active');
          slideUp(list, 150);
        } else {
          container.querySelectorAll('.filter-sort .filter-sort__list').forEach(l => {
            if (l === list) return; // skip the one we're about to open
            l.classList.remove('filter-sort__list--active');
            slideUp(l, 150);
          });
          list?.classList.add('filter-sort__list--active');
          slideDown(list, 150); // use slideDown directly instead of slideToggle
        }
        if (title.classList.contains('filter-sort__title--active')) {
          title.classList.remove('filter-sort__title--active');
          title.setAttribute('aria-expanded', 'false');
        } else {
          title.setAttribute('aria-expanded', 'true');
          container.querySelectorAll('.filter-sort .filter__title').forEach(t => {
            t.classList.remove('filter-sort__title--active');
          });
          title.classList.toggle('filter-sort__title--active');
        }
      });
    });
    document.addEventListener('click', handleDocumentClickResize);
  }

  // Sort Mobile
  if (width < 600) {
    document.querySelectorAll('.filter-sort').forEach(sort => {
      sort.addEventListener('click', (e) => {
        e.preventDefault();
        sort.querySelector('.filter-sort__list')?.classList.toggle('filter-sort__list--active');
        document.querySelector('.filter-sort-overlay')?.classList.toggle('filter-sort-overlay--active');
        document.querySelector('.filters__container')?.classList.remove('filters__container--sticky');
        document.documentElement.classList.toggle('no-scroll');
        document.querySelector('.filters')?.classList.toggle('filters--active');
      });
    });
    document.addEventListener('click', handleDocumentClickResize);
  }
}

function handleDocumentClickResize(e) {
  const width = window.innerWidth;

  if (width > 599 && !e.target.closest('.filter-sort')) {
    document.querySelectorAll('.filter-sort__list').forEach(l => {
      l.classList.remove('filter-sort__list--active');
      slideUp(l, 150);
    });
    document.querySelectorAll('.filter-sort__title').forEach(t => {
      t.classList.remove('filter-sort__title--active');
    });
  }

  if (width < 600 && !e.target.closest('.filter-sort') && !e.target.closest('.filter__group')) {
    document.querySelectorAll('.filter-sort__list').forEach(l => {
      l.classList.remove('filter-sort__list--active');
    });
    document.querySelector('.filter-sort-overlay')?.classList.remove('filter-sort-overlay--active');
    document.documentElement.classList.remove('no-scroll');
    setTimeout(() => {
      document.querySelector('.filters')?.classList.remove('filters--active');
    }, 500);
  }
}

// Filters All
document.addEventListener('DOMContentLoaded', () => {
  _initResize();
  _initFilter();

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.filter__title') ||
      e.target.closest('.filter__group')
    ) return;

    document.querySelectorAll('.filter__list').forEach(list => {
      list.classList.remove('filter__list--active');
      slideUp(list, 150);
    });
    document.querySelectorAll('.filter__title').forEach(title => {
      title.classList.remove('filter__title--active');
    });
  });
});

function _initFilter() {
  replaceElement('.filter__title');

  document.querySelectorAll('.filter__title').forEach(title => {
    title.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const list = title.nextElementSibling;
      const container = title.closest('.filter__group')?.parentElement;

      if (list?.classList.contains('filter__list--active')) {
        list.classList.remove('filter__list--active');
        slideUp(list, 150);
      } else {
        container?.querySelectorAll('.filter__group .filter__list').forEach(l => {
          if (l === list) return; // skip the one we're about to open
          l.classList.remove('filter__list--active');
          slideUp(l, 150);
        });
        container?.querySelectorAll('.filter__group .filter__title').forEach(t => {
          t.classList.remove('filter__title--active');
        });
        list?.classList.toggle('filter__list--active');
        slideDown(list, 150); // use slideDown directly instead of slideToggle
      }

      if (title.classList.contains('filter__title--active')) {
        title.classList.remove('filter__title--active');
        title.setAttribute('aria-expanded', 'false');
      } else {
        title.classList.add('filter__title--active');
        title.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function replaceElement(selector) {
  document.querySelectorAll(selector).forEach(el => {
    const clone = el.cloneNode(true);
    el.parentNode?.replaceChild(clone, el);
  });
}

/*****************************************
FILTERS/SORT - BASED ON DAWN
******************************************/

//global dawn functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function loaderSpinner(isshow) {
  if (isshow) {
    document.querySelector('.loader').style.display='block';
  }
  else {
    document.querySelector('.loader').style.display='none';
  }
}

//options
const filterOptions = {
  useCache : true  // true or false
}
var filterData=[]; //this cache for store already filtered data
var searchParamsInitial = window.location.search.slice(1);
var searchParamsPrev = window.location.search.slice(1);
var _priceSlider;
if (document.querySelector('[data-filters-active]')) {
  initFilterSd();
}

function initFilterSd() {
  //add listeners
  // history lsitener for back/next button
  const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : searchParamsInitial;
      if (searchParams === searchParamsPrev) return;
      renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  // filter value click
  
  document.querySelector('[data-container="filters"]').addEventListener('click', function (e) {
     if(e.target.tagName=="INPUT") {
      renderFilterData(e);
     }
  });

  document.querySelector('[data-filters-active]').addEventListener('click', function (e) {
     const el=e.target.dataset.activefilter || (e.target.closest('[data-activefilter]') && e.target.closest('[data-activefilter]').dataset.activefilter);
     if(el) {
       if (e.target.dataset.priceremove || (e.target.closest('[data-priceremove]') && e.target.closest('[data-priceremove]').dataset.priceremove)) {
         //_priceSlider.noUiSlider.reset();
        const minEl=document.querySelector('[data-filterminparam]'); 
        const maxEl=document.querySelector('[data-filtermaxparam]');	
        if (minEl) minEl.value='';
        if (maxEl) maxEl.value='';
          document.getElementById("amount").value=currencySymbol+ _priceSlider.noUiSlider.get()[0] + " - " +  currencySymbol+_priceSlider.noUiSlider.get()[1];	
       }
       renderPage(el.indexOf('?') == -1? "" : el.slice(el.indexOf('?') + 1));
     }
  });

  document.querySelector('[data-sort-container]').addEventListener('click', function (e) {
    const el = e.target.dataset.sortby;
    if (el) {
      document.querySelectorAll('.filter-sort__item').forEach(x => {
        if (x != e.target) x.classList.remove('filter-sort__item--active');
      });
      e.target.classList.add('filter-sort__item--active');
      document.querySelector('.filter-sort__title').innerText = e.target.innerText;

      // close the dropdown after selection
      //document.querySelector('.filter-sort__list').classList.remove('filter-sort__list--active');
      document.querySelectorAll('.filter-sort__title').forEach(t => {
        t.classList.remove('filter-sort__title--active');
        t.setAttribute('aria-expanded', 'false');
      });

      renderFilterData(e);
    }
  });

  const priceRangeEl=document.querySelector('[data-filter-price]');
  if (priceRangeEl) {
  var currencySymbol='£';

  const minEl=document.querySelector('[data-filterminparam]'); 
  const maxEl=document.querySelector('[data-filtermaxparam]');	  
  const minPrice=minEl && minEl.value!=''?minEl.value: 0;
  const maxPrice=maxEl && maxEl.value!=''?maxEl.value:priceRangeEl.dataset.filtermax;
  
  _priceSlider = document.getElementById('slider-range');
  if (_priceSlider) {
	noUiSlider.create(_priceSlider, {
    	start: [parseInt(minPrice),parseInt(maxPrice)],
    	connect: true,
    	range: {
        	'min':  0,
        	'max':parseInt(priceRangeEl.dataset.filtermax)
    	}
	});
  
  	_priceSlider.noUiSlider.on('set', function (values, handle, unencoded, isTap, positions) {
          document.querySelector('[data-filterminparam]').value=values[0]; 
          document.querySelector('[data-filtermaxparam]').value=values[1];			         		  
          document.getElementById("amount").value=currencySymbol+ _priceSlider.noUiSlider.get()[0] + " - " +  currencySymbol+_priceSlider.noUiSlider.get()[1];		
          renderFilterData();
	});
  	document.getElementById("amount").value=currencySymbol+ _priceSlider.noUiSlider.get()[0] + " - " +  currencySymbol+_priceSlider.noUiSlider.get()[1];	
  }
  }
  renderAdditionalData();
}


function renderPage(searchParams, event){
  searchParamsPrev = searchParams;
  //build url
  const section=document.querySelector('[data-collection-container]').dataset.id; // get section to retrive only collection section instead of whole page
  const url = `${window.location.pathname}?section_id=${section}&${searchParams}`; 
  //put to history state so we can use prev/next browser button
  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  //fetch html for filtered data
  //here need put show loading overlay
   const filterDataUrl = (element) => element.url === url; // create new cache element for check is this this url already in cache
   (filterOptions.useCache === true && filterData.some(filterDataUrl))
        ? renderSectionFromCache(filterDataUrl, event)
        : renderSectionFromFetch(url, event);
}
function renderFilterData(e) {
  //serialize filters container for get form data
  const formData = new FormData();
  //get all filter value
  document.querySelectorAll('[data-container="filters"] input:checked').forEach((element) => {
    formData.append(element.name,element.value);
  });
  document.querySelectorAll('[data-container="filters"] [data-filter-search]').forEach((element) => {
    formData.append(element.name,element.value);
  });
  //get price filter
  const minEl=document.querySelector('[data-filterminparam]'); 
  const maxEl=document.querySelector('[data-filtermaxparam]');	
  if (minEl && minEl.value!='') formData.append(minEl.name,minEl.value);
  if (maxEl && maxEl.value!='') formData.append(maxEl.name,maxEl.value);
  //get sortby
  const sortEl=document.querySelector('[data-sortby].filter-sort__item--active');
  if (sortEl) formData.append("sort_by",sortEl.dataset.sortby);
  //generate searchparam string
  const searchParams=new URLSearchParams(formData).toString();
  renderPage(searchParams,e);
}

function renderSectionFromFetch(url, event) {
    loaderSpinner(true);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        if (filterOptions.useCache === true ) 
          filterData = [...filterData, { html, url }]; // put to cache
        renderFilters(html, event);
        renderProductContainer(html);
        renderProductCount(html);
        renderAdditionalData();
        loaderSpinner(false);
      });
  }

function renderSectionFromCache(filterDataUrl, event) {
    const html = filterData.find(filterDataUrl).html;
    renderFilters(html, event);
    renderProductContainer(html);
    renderProductCount(html);
    renderAdditionalData();
}


function renderProductContainer(html) {
    document.querySelector('[data-collection-container]').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-collection-container]').innerHTML;
}

function renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-count-container]').innerHTML;
    const container = document.querySelector('[data-count-container]');    
    container.innerHTML = count;
    
}

function renderFilters(html, event) {
  
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '[data-filter]'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '[data-filter]'
    );

    // Remove filters that are no longer returned from the server, this mostly for OR logic
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ dataset }) => currentElement.dataset.filter === dataset.filter)) {
        currentElement.remove();
      }
    });

    //function for check and not rerender current filter group (where user select last filter value)
    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('[data-filter]') : undefined;
      return jsFilter ? element.dataset.filter === jsFilter.dataset.filter : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.querySelector(`[data-filter="${elementToRender.dataset.filter}"]`);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
       currentElement.querySelector('[data-filter-list]').innerHTML = elementToRender.querySelector('[data-filter-list]').innerHTML;
      } else {
        // need check how add new filter group
      }
    });

    const parsedDom=new DOMParser()
      .parseFromString(html, 'text/html');
    //render active filters
   const activeFiltersDom=parsedDom.querySelector('[data-filters-active]');
   document.querySelector('[data-filters-active]').innerHTML =activeFiltersDom ? parsedDom.querySelector('[data-filters-active]').innerHTML:"";

  // render pagination
  const paginationDom=parsedDom.querySelector('[data-paginate-container]');
  document.querySelector('[data-paginate-container]').innerHTML =paginationDom ? paginationDom.innerHTML:'';
  


}

function renderAdditionalData() {
  _initFilter();
  if (window.ReloadSmartWishlist!=undefined) {
    ReloadSmartWishlist();
  }
  //here need put hide loading overlay
}


//search functions
const searchOptions= {
   searchFormSelector: '[data-searchform]',
   useCache : true  // true or false
}

let searchCachedResults = {},    
    searchIsOpen = false,
    searchAbortController = new AbortController(),
    searchSearchTerm = '',
    searchForm,
    predictiveSearchResults,
    resultsMaxHeight ;

function initSearchSd() {

    searchForm=document.querySelector(searchOptions.searchFormSelector);
    predictiveSearchResults = searchForm.querySelector('[data-predictive-search]')
    //searchForm.addEventListener('submit', this.onFormSubmit.bind(this));

    //this.input.addEventListener('focus', this.onFocus.bind(this));
    //this.addEventListener('focusout', this.onFocusOut.bind(this));
    //this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
    let searchInput=searchForm.querySelector('input[type="search"]');
    searchInput.addEventListener(
        'input',
        debounce((event) => {
          searchOnChange(event);
        }, 300)
    );

    searchForm.querySelector('button[type="reset"]').addEventListener(
        'click',
        function() {
          searchInput.value='';
          searchOnChange();
          toggleResetButton();
        }
    );
}


function searchGetQuery() {  
    return  searchForm.querySelector('input[type="search"]').value.trim();
}

function  searchOnChange() {
    const newSearchTerm = searchGetQuery();
    if (!searchSearchTerm || !newSearchTerm.startsWith(searchSearchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      searchForm.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    updateSearchForTerm(searchSearchTerm, newSearchTerm);

    searchSearchTerm = newSearchTerm;

    if (!searchSearchTerm.length) {
      closeSearchPredict(true);
      return;
    }

    getSearchResults(searchSearchTerm);
    toggleResetButton() ;
}

 function updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = searchForm.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

 function getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    //this.setLiveRegionLoadingState();

    if (searchCachedResults[queryKey]) {
      renderSearchResults(searchCachedResults[queryKey]);
      return;
    }

    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: searchAbortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          closeSearchPredict();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;                
          searchCachedResults[queryKey] = resultsMarkup;        
        renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        closeSearchPredict();
        throw error;
      });
  }

function renderSearchResults(resultsMarkup) {
    predictiveSearchResults.innerHTML = resultsMarkup;
    //this.setAttribute('results', true);

    //this.setLiveRegionResults();
    openSearchPredict();
  }

function getResultsMaxHeight() {
    resultsMaxHeight =
      window.innerHeight - document.querySelector('header').getBoundingClientRect().bottom;
    return resultsMaxHeight;
  }

function  openSearchPredict() {
    predictiveSearchResults.style.maxHeight = resultsMaxHeight || `${getResultsMaxHeight()}px`;
    //this.setAttribute('open', true);
    //this.input.setAttribute('aria-expanded', true);
    searchIsOpen = true;
    document.querySelector(".header-search__form").classList.add("header-search__form--open");
  }

function closeSearchPredict(clearSearchTerm = false) {
    closeSearchPredictResults(clearSearchTerm);
    searchIsOpen = false;
    document.querySelector(".header-search__form").classList.remove("header-search__form--open");
  }

function closeSearchPredictResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      searchForm.querySelector('input[type="search"]').value = '';
      //this.removeAttribute('results');
    }
    //const selected = this.querySelector('[aria-selected="true"]');

    //if (selected) selected.setAttribute('aria-selected', false);

    //this.input.setAttribute('aria-activedescendant', '');
    //this.removeAttribute('loading');
    //this.removeAttribute('open');
   // this.input.setAttribute('aria-expanded', false);
    resultsMaxHeight = false;
    predictiveSearchResults.removeAttribute('style');
  //}
}

 function toggleResetButton() {
    const resetButton=searchForm.querySelector('button[type="reset"]');
    const resetIsHidden = resetButton.classList.contains('hidden');
    if (searchGetQuery().length > 0 && resetIsHidden) {
      resetButton.classList.remove('hidden');
    } else if (searchGetQuery().length === 0 && !resetIsHidden) {
      resetButton.classList.add('hidden');
    }
  }

initSearchSd();